import React from 'react';
import { translate } from 'react-i18next';
import { Rating, Segment, Header, Button, Container, Grid, Message, Icon } from 'semantic-ui-react';

import PluginsContainer from 'modules/plugins/PluginsContainer.js';
import SurveyButtons from './SurveyButtons.js';
import Utils from 'utils/Utils.js';
import {colors, fontSizes, spacings} from 'style';
import LoadInline from 'modules/loading/LoadInline.js';
import Portal from 'modules/misc/Portal.js';

import styleDef from './style.js'
var style= {
    ...styleDef,
    continueButton: {
        position: 'fixed',
        left: '50%',
        bottom: spacings.base,
        zIndex: '50',
        marginLeft: '-165px',
    },
    plugins: {
        paddingBottom: spacings.xlarge,
    },
    spacer: {
        height: '50px',
    },
    centered: {
        textAlign: 'center',
    }
};

const SurveyPageSyncContacts = ({t, surveyPage, error, onSkip, onSubmit, onConnect}) => (
    <PluginsContainer typeTag="pedometer" noNav bodyStyle={style.plugins} onConnect={onConnect}>
        <div style={style.centered}>
        <div style={style.header}>{surveyPage.title}</div>
        <div style={style.description}>
            {Utils.endlToBr(surveyPage.description)}
        </div>
        <div style={style.spacer} />
        </div>
        <Portal>
            <Button style={{...style.tealButton, ...style.continueButton}} onClick={onSubmit}>{t('Continue')}</Button>
        </Portal>
    </PluginsContainer>
);

export default translate('surveys')(SurveyPageSyncContacts);



// WEBPACK FOOTER //
// ./src/modules/surveys/types/SurveyPageSyncDevices.js